export default "__VITE_ASSET__COUYnkQj__"